import { render } from "./globalLogout.vue?vue&type=template&id=6fb57e5a"
import script from "./globalLogout.vue?vue&type=script&lang=js"
export * from "./globalLogout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__